import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";

export const CTABand = ({
  eyebrow,
  title = "Let's build a smarter recruitment partnership",
  description = "Whether you are hiring, seeking your next role, or looking to collaborate, our team is ready to help.",
  primary = { label: "Become a Recruitment Partner", to: "/partnerships#register" },
  secondary = { label: "Contact Us", to: "/contact" },
}) => (
  <section className="relative overflow-hidden bg-navy py-20 lg:py-24" data-testid="cta-band">
    <div className="absolute -left-20 top-0 h-72 w-72 rounded-full bg-gold/10 blur-3xl" />
    <div className="absolute -right-10 bottom-0 h-72 w-72 rounded-full bg-white/5 blur-3xl" />
    <Reveal className="relative mx-auto max-w-4xl px-6 text-center lg:px-8">
      {eyebrow && <span className="overline mb-4 inline-block text-xs text-gold-light" data-testid="cta-eyebrow">{eyebrow}</span>}
      <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">{title}</h2>
      <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-white/75">{description}</p>
      <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
        <Link to={primary.to} className="inline-flex items-center gap-2 rounded-lg bg-gold px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-gold-dark" data-testid="cta-primary">
          {primary.label} <ArrowRight className="h-4 w-4" />
        </Link>
        <Link to={secondary.to} className="inline-flex items-center gap-2 rounded-lg border border-white/25 px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-white/10" data-testid="cta-secondary">
          {secondary.label}
        </Link>
      </div>
    </Reveal>
  </section>
);

export default CTABand;
